import {
  LISTADO_OPERACIONES_EJECUTIVO,
  LISTADO_OPERACIONES_CLIENTE,
} from '@/helpers/urls';
import {
  OperacionListadoCliente,
  OperacionListadoEjecutivo,
} from '@/models/respuestas/detalleOperacion.model';
import RespuestaApi from '@/models/respuestas/resApi.model';
import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuery from './axiosBaseQuery';
import { GET } from '@/providers/api';

export const operacionesApi = createApi({
  reducerPath: 'operacionesApi',
  baseQuery: axiosBaseQuery(),
  keepUnusedDataFor: 1,
  endpoints: (builder) => ({
    obtenerOperacionesEjecutivo: builder.query<
      OperacionListadoEjecutivo[],
      void
    >({
      query: () => ({ endpoint: LISTADO_OPERACIONES_EJECUTIVO, method: GET }), // Asegúrate de que LISTADO_OPERACIONES_EJECUTIVO sea la ruta correcta
      transformResponse: (res: RespuestaApi<OperacionListadoEjecutivo[]>) =>
        res.resultado,
    }),
    obtenerOperacionesCliente: builder.query<OperacionListadoCliente[], void>({
      query: () => ({
        endpoint: LISTADO_OPERACIONES_CLIENTE,
        method: GET,
      }), // Asegúrate de que LISTADO_OPERACIONES_CLIENTE sea la ruta correcta
      transformResponse: (res: RespuestaApi<OperacionListadoCliente[]>) =>
        res.resultado,
    }),
  }),
});

export const {
  useObtenerOperacionesEjecutivoQuery,
  useObtenerOperacionesClienteQuery,
} = operacionesApi;
